var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-8037.09,-1017.52)"},React.createElement("g",{"transform":"matrix(1,0,0,1.6,6834,0)"},React.createElement("g",{"transform":"matrix(1.71429,0,0,1.07143,1194.52,630.595)"},React.createElement("path",{"d":"M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z","style":{"fill":"white","fillRule":"nonzero"}})))));
}

Close.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Close;

Close.default = Close;
